<template>
  <div id="votePc" :style="backgroundStyle">
    <div class='search'>
      <!-- <div class='search-container'>
        <input v-model="searchName" placeholder="请输入姓名查找" @input="searchOnInput" @keypress="searchNext"/>
        <img src="./assets/search.png" style="cursor: pointer" @click="searchNext">
      </div> -->
    </div>
    <div class='us'>
      <User v-for="(item,index) in users" :key="item.id" :ref="'user' + item.id"
            :searchCurrent="userSearch.current === item.id"
            :searchMatch="userSearch.ids.includes(item.id)" :searchName="searchName" :userInfo="item"
            @addVote='addVote' @showDetail='showDetail(index)'></User>
    </div>

    <div id="userDetail">
      <Person :userInfo='userInfo' @dispear='dispear'></Person>
    </div>
    <div class='gzh'>
      <img alt="" src="@/assets/gzh.jpg">
      <span>中国品牌发展网</span>
      <span>微信公众号</span>
      <span>（手机投票）</span>
    </div>
    <div class='phoneClient'></div>
    <img alt="" class='goTop' src="@/assets/gotop.png" @click="goTop"> />
  </div>
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'
import User from '@/components/user.vue'
import Person from '@/components/person'

export default {
  name: 'VotePc',
  components: {
    // HelloWorld
    User,
    Person
  },

  data() {
    return {
      searchName: '',
      users: [],
      totalUsers: [],
      scrollTop: 0,
      userInfo: {},
      backgroundStyle: {},
      voteInterval:{},
      userSearch: {
        ids: [],
        current: 0,
        jobId: 0
      }
    }
  },

  async created() {
    try {
      await this.updataUsers()
      this.voteInterval = setInterval(async()=>{
        await this.getAllNumbers()
      },1000 * 90)

      this.refreshBackground()
    } catch (error) {
      console.log('created',error)
    }

  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    dispear() {
      document.getElementById('userDetail').style.display = 'none'
    },
    showDetail(index) {
      this.userInfo = this.users[index]
      document.getElementById('userDetail').style.display = 'block'
    },

    handleScroll() {
      let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
      this.scrollTop = scrollTop;
    },

    goTop() {

      let timer = setInterval(() => {
        let ispeed = Math.floor(-this.scrollTop / 10);
        document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop + ispeed;
        if (this.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 10);
    },

    async addVote() {
      try {
        // let res = await this.$request.post(`/server/vote/${id}`, {})
        // if (res.code == 200) {
        //   await this.getAllNumbers()
        // } else {
        //   this.$message(res && res.data);
        // }
        this.$alert('投票已结束，感谢关注');
      } catch (error) {
        console.log('addVote', error);
      }
    },

    async getAllNumbers() {
      try {
        let res = await this.$request.get('/server/vote/number') //https://api.brandzg.net/server/vote/number
        if (res.code == 200) {
          let data = res.data
          for (let i = 0; i < this.totalUsers.length; i++) {
            let value = this.totalUsers[i]
            if (value && value.id) {
              value.number = data[value.id]
            }
          }
          this.users = [...this.totalUsers]
        }
      } catch (error) {
        console.log('getAllNumbers', error);
      }
    },

    async updataUsers() {
      try {
        let res = await this.$request.get('/server/vote/list')
        if (res.code == 200) {
          let list = res.data;
          this.totalUsers = []
          for (let i = 0; i < list.length; i++) {
            let value = list[i]
            this.totalUsers.push(value)
          }
          this.users = [...this.totalUsers]
        }
        console.log('res', res)
      } catch (error) {
        console.log('updataUsers', error)
      }
    },

    async searchNext(event) {
      if (event.type !== 'click' && !(event.type === 'keypress' && event.key === 'Enter')) {
        return
      }
      if (this.userSearch.ids.length < 2) {
        return
      }
      let index = this.userSearch.ids.indexOf(this.userSearch.current)
      if (++index >= this.userSearch.ids.length) {
        index = 0
      }
      this.userSearch.current = this.userSearch.ids[index];

      this.jumpPageScroll();
    },

    jumpPageScroll() {
      let ele = this.$refs['user' + this.userSearch.current][0].$el;
      document.documentElement.scrollTop = ele.offsetTop - (window.innerHeight - ele.offsetHeight) / 2
    },

    searchOnInput() {
      if (this.userSearch.jobId) {
        clearTimeout(this.userSearch.jobId);
      }
      this.userSearch.jobId = setTimeout(this.doSearch, 300);
    },

    doSearch() {
      this.userSearch.ids = []
      let searchName = this.searchName.replaceAll(' ', '');

      if (!searchName) {
        this.userSearch.ids = []
        this.userSearch.current = 0
        return
      }

      for (let i = 0; i < this.totalUsers.length; i++) {
        let value = this.totalUsers[i]
        if (value && value.name && value.name.includes(searchName)) {
          this.userSearch.ids.push(value.id)
        }
      }

      if (this.userSearch.ids.length) {
        this.userSearch.current = this.userSearch.ids[0]
        this.jumpPageScroll()
      } else {
        this.userSearch.current = 0
      }
    },

    refreshBackground() {
      this.$request.get('/server/vote/banner').then(resp => {
        if (resp.code === 200) this.backgroundStyle = resp.data;
      })
    }
  },

  beforeDestroy(){
    if(this.voteInterval){
      clearInterval(this.voteInterval)
    }
  },

  watch: {
    searchName(newValue) {
      if (!newValue.replace(' ', '')) {
        this.users = [...this.totalUsers]
      }
    }
  },

}
</script>

<style lang='less'>

::-webkit-scrollbar {
  width: 2px;
  background-color: #333;
}

html > body {
  padding: 0;
  margin: 0;
}

#votePc {
  padding-top: 500px;
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: top;
  padding-left: 65px;
  padding-right: 65px;
  display: flex;
  flex-direction: column;

  .goTop {
    position: fixed;
    bottom: 30px;
    height: 50px;
    right: 30px;
    width: 30px;
    cursor: pointer;
  }

  .gzh {
    padding: 10px;
    display: flex;
    align-items: center;
    flex-direction: column;
    position: fixed;
    top: 50%;
    left: 30px;
    margin-top: -50px;

    img {
      width: 110px;
      height: 110px;
    }

    span {
      color: white;
    }
  }

  .search {
    margin-bottom: 50px;
    width: 1400px;
    align-self: center;
    display: flex;
    justify-content: flex-end;

    .search-container {
      margin-right: 20px;

      display: flex;
      justify-content: center;
      align-items: center;
      width: 200px;
      background-color: #fff;

      input {
        border: 0;
        outline: none;
        font-size: 12px;
      }

      img {
        width: 26px;
        height: 26px;
      }
    }

  }

  .us {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 10px;
    align-self: center;
    width: 1400px;
  }

  #userDetail {
    position: fixed;
    display: none;
    left: 50%;
    top: 50%;
    margin-left: -160px;
    margin-top: -200px;
    z-index: 9500;
    background-color: white;
    border: 1px solid #999;
    border-radius: 10px;
  }
}
</style>
